import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
}
export function CTAButton({
  children,
  href = '#pricing',
  className = ''
}: CTAButtonProps) {
  const isAnchor = href.startsWith('#');
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!isAnchor) return;
    event.preventDefault();
    document.getElementById(href.slice(1))?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <a href={href} onClick={handleClick} target={isAnchor ? undefined : '_blank'} rel={isAnchor ? undefined : 'noopener noreferrer'} className={`block w-full rounded-md border-b-4 border-[#4B2028] bg-brand-burgundy px-3 py-3.5 text-center font-button text-sm font-extrabold tracking-wide text-white shadow-[0_4px_12px_rgba(110,48,59,.24)] transition hover:bg-brand-burgundyHover hover:shadow-[0_6px_16px_rgba(110,48,59,.3)] active:translate-y-0.5 active:border-b-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-burgundy sm:text-base ${className}`} data-id="element-31">
      {children}
    </a>;
}